import { autoinject, transient } from "aurelia-framework";
import { MdmPipelineClientService } from "../../../../../../services/modules/mdm-pipeline.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";

@autoinject()
@transient()
export class CustomPipelineExecutionDialog {

    public pipeline: { name: string, key: string, commands: { name: string, key: string }[] };
    public commands: { key: string }[] = [];
    public pipelines: { name: string, key: string, commands: { name: string, key: string }[] }[] =
        [
            {
                name: "Vessel",
                key: "Vessel",
                commands: [
                    { name: "Get Changed Entities", key: "GetChangedEntities" },
                    { name: "Get Entity Details", key: "GetEntityDetails" },
                    { name: "Update Mdm Entities", key: "UpdateMdmEntities" },
                    { name: "Execute Safety Net", key: "ExecuteSafetyNetConfigurations" },
                    { name: "Reset Temporary Data Steward", key: "ResetTemporaryDataSteward" },
                    { name: "Execute Master Records Entity", key: "ExecuteMasterRecordsEntity" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "Company",
                key: "Company",
                commands: [
                    { name: "Get Changed Entities", key: "GetChangedEntities" },
                    { name: "Get Entity Details", key: "GetEntityDetails" },
                    { name: "Update Mdm Entities", key: "UpdateMdmEntities" },
                    { name: "Execute Safety Net", key: "ExecuteSafetyNetConfigurations" },
                    { name: "Reset Temporary Data Steward", key: "ResetTemporaryDataSteward" },
                    { name: "Execute Master Records Entity", key: "ExecuteMasterRecordsEntity" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "Psc",
                key: "Psc",
                commands: [
                    { name: "Get Changed Entities", key: "GetChangedEntities" },
                    { name: "Get Entity Details", key: "GetEntityDetails" },
                    { name: "Update Mdm Entities", key: "UpdateMdmEntities" },
                    { name: "Execute Safety Net", key: "ExecuteSafetyNetConfigurations" },
                    { name: "Reset Temporary Data Steward", key: "ResetTemporaryDataSteward" },
                    { name: "Execute Master Records Entity", key: "ExecuteMasterRecordsEntity" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "Incident",
                key: "Incident",
                commands: [
                    { name: "Get Changed Entities", key: "GetChangedEntities" },
                    { name: "Get Entity Details", key: "GetEntityDetails" },
                    { name: "Update Mdm Entities", key: "UpdateMdmEntities" },
                    { name: "Execute Safety Net", key: "ExecuteSafetyNetConfigurations" },
                    { name: "Reset Temporary Data Steward", key: "ResetTemporaryDataSteward" },
                    { name: "Execute Master Records Entity", key: "ExecuteMasterRecordsEntity" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "GHG Rating",
                key: "GHG Rating",
                commands: [
                    { name: "Load Data Records", key: "LoadDataRecords" },
                    { name: "Execute Generate DWH Vessel States", key: "GenerateDWHVesselStates" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "Safety Score",
                key: "SafetyScore",
                commands: [
                    { name: "Load Data Records", key: "LoadDataRecords" },
                    { name: "Execute Generate DWH Vessel States", key: "GenerateDWHVesselStates" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            },
            {
                name: "Event",
                key: "Event",
                commands: [
                    { name: "Get Changed Entities", key: "GetChangedEntities" },
                    { name: "Get Entity Details", key: "GetEntityDetails" },
                    { name: "Update Mdm Entities", key: "UpdateMdmEntities" },
                    { name: "Execute Safety Net", key: "ExecuteSafetyNetConfigurations" },
                    { name: "Reset Temporary Data Steward", key: "ResetTemporaryDataSteward" },
                    { name: "Execute Master Records Entity", key: "ExecuteMasterRecordsEntity" },
                    { name: "Sync Data Records", key: "SyncDataRecords" },
                    { name: "All", key: "All" }
                ]
            }
        ];

    constructor(private mdmPipelineClientService: MdmPipelineClientService,
        private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService) { }

    activate() { }

    addCommand() {
        this.commands.push({ key: null });
    }

    trigger() {
        return new Promise<void>((resolve, reject) => {
            this.mdmPipelineClientService.runPipelineCommands(this.pipeline.key, this.commands.map(x => x.key)).then(() => {
                this.notificationClientService.show("Custom Pipeline Execution Enqued Successfully!", "", NotificationType.Success);
                this.dialogClientService.hide();
                resolve();
            }).catch(() => {
                this.notificationClientService.show("Failed to Enqueu Custom Pipeline Execution!", "", NotificationType.Error);
                reject();
            });
        });
    }

    cancel() {
        this.dialogClientService.hide();
    }
}